import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
    Container,
    Heading,
    Text,
    Box,
    Badge,
    Wrap,
    Grid,
    AspectRatio,
    Image,
} from '@chakra-ui/core';
import Programma from './programma';

const StudioSinglePast = ({ studio }) => {
    return (
        <div>
            <Box bg='black' color='white'>
                {/* <ScrollToTop /> */}
                <Helmet>
                    <title>{studio.title}</title>
                </Helmet>

                <Container maxW='1312px' py={[4, 4, 8, 12]}>
                    <Grid
                        templateColumns={{
                            base: '1fr',
                            sm: '1fr',
                            md: '2fr 1fr',
                            lg: '2.5fr 1fr',
                        }}
                        gap={{
                            base: 4,
                            sm: 4,
                            md: 6,
                            lg: 10,
                        }}
                    >
                        <Box minW='0'>
                            <Heading as='h3' size='lg' color='brand.500' mb={[4, 4, 6]}>
                                {studio.title}
                            </Heading>
                            <Box mb={[4, 4, 6, 10]}>
                                <AspectRatio
                                    // ratio={16 / 9}
                                    ratio={1.7777}
                                    borderRadius='md'
                                    style={{ overflow: 'hidden' }}
                                >
                                    <>
                                        <>
                                            <iframe
                                                title='xxxxxx'
                                                allowFullScreen
                                                src={`https://www.youtube.com/embed/${studio.liveVideoUrl}`}
                                                allow='autoplay'
                                            />
                                        </>
                                    </>
                                </AspectRatio>
                            </Box>

                            <Grid
                                templateColumns={{
                                    base: '1fr',
                                    sm: '1fr',
                                    md: '1fr',
                                }}
                                gap={{
                                    base: 4,
                                    sm: 4,
                                    md: 6,
                                }}
                            >
                                <>
                                    {studio.mainStudioProgrammas && (
                                        <>
                                            {studio.mainStudioProgrammas.map(
                                                (
                                                    { mainStudioProgrammaItems, title, id },
                                                    index,
                                                ) => {
                                                    return (
                                                        <Programma
                                                            key={id}
                                                            title={title}
                                                            id={id}
                                                            mainStudioProgrammaItems={
                                                                mainStudioProgrammaItems
                                                            }
                                                        />
                                                    );
                                                },
                                            )}
                                        </>
                                    )}
                                </>
                            </Grid>
                        </Box>
                    </Grid>
                </Container>
            </Box>
        </div>
    );
};

export default StudioSinglePast;
